/*
 * FarmSteady — interaction event tracking (2026-08-02 batch).
 *
 * Pushes fs_* events into window.dataLayer for GTM to forward to GA4.
 * One capture-phase delegated click listener; selectors are the stable
 * class hooks each section already renders. Pushes are inert until the
 * GTM container has a matching Custom Event trigger (regex ^fs_), so
 * shipping this ahead of the GTM config is safe.
 *
 * Event vocabulary (event name = the decision surface, fs_label = which
 * specific thing, fs_area = sub-slot where one surface has several):
 *   fs_drawer_open / fs_drawer_close  — nav drawer toggle
 *   fs_drawer_nav   — drawer link clicks (area: pill|feature|category|quiet)
 *   fs_search_click — predictive search (area: predictive_result|predictive_chip)
 *   fs_chip_click   — collection project chips
 *   fs_hero_click   — homepage hero (area: cta|media)
 *   fs_rail_click   — PDP recipe rail cards
 *   fs_gifts_click  — gifts hub (area: card|band_all)
 *   fs_video_play   — videos page card plays (label = video id)
 *   fs_sticky_atc   — sticky ATC chip button (the add_to_cart ecommerce
 *                     event itself flows through Elevar via <product-form>;
 *                     this event only attributes WHICH button was used)
 */

(function () {
  'use strict';

  function push(name, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, params));
  }

  function label(el) {
    var t = (el.textContent || '').trim().replace(/\s+/g, ' ');
    return (t || el.getAttribute('href') || '').slice(0, 100);
  }

  // Order matters where surfaces nest (hero CTA sits over the media link).
  var RULES = [
    ['.fs-drawer__pill', 'fs_drawer_nav', { fs_area: 'pill' }],
    ['.fs-drawer__feature', 'fs_drawer_nav', { fs_area: 'feature' }],
    ['.fs-drawer__cat', 'fs_drawer_nav', { fs_area: 'category' }],
    ['.fs-drawer__link', 'fs_drawer_nav', { fs_area: 'quiet' }],
    ['.fs-ps__link', 'fs_search_click', { fs_area: 'predictive_result' }],
    ['.fs-ps__chip', 'fs_search_click', { fs_area: 'predictive_chip' }],
    ['.fs-tag-pills__pill', 'fs_chip_click', {}],
    ['.fs-hero__cta', 'fs_hero_click', { fs_area: 'cta' }],
    ['.fs-hero__media-link', 'fs_hero_click', { fs_area: 'media' }],
    ['.fs-rail-card', 'fs_rail_click', {}],
    ['.fs-gift-card', 'fs_gifts_click', { fs_area: 'card' }],
    ['.fs-gifts-hub__band-all', 'fs_gifts_click', { fs_area: 'band_all' }],
    ['.fs-vid__card', 'fs_video_play', {}],
    ['.fs-sticky-atc__button', 'fs_sticky_atc', {}],
  ];

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      for (var i = 0; i < RULES.length; i++) {
        var el = e.target.closest(RULES[i][0]);
        if (!el) continue;
        var params = Object.assign({}, RULES[i][2]);
        params.fs_label =
          el.getAttribute('data-video-id') || label(el);
        push(RULES[i][1], params);
        return;
      }
    },
    { capture: true, passive: true }
  );

  function initDrawer() {
    var drawer = document.getElementById('Details-menu-drawer-container');
    if (!drawer) return;
    drawer.addEventListener('toggle', function () {
      push(drawer.open ? 'fs_drawer_open' : 'fs_drawer_close', {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }
})();
